import { z } from 'zod';

// TODO: refine after Data Structure doc review
// A Milestone is a saved lens: a filter spec over the Pool plus a research focus
// the AI uses when summarising or answering questions within that scope.

export const MilestoneFilterSpecSchema = z.object({
  buildMarkerIds: z.array(z.string().uuid()).optional(),
  buildStages: z.array(z.string()).optional(),
  topics: z.array(z.string()).optional(),
  sentimentLabels: z.array(z.string()).optional(),
  severityLabels: z.array(z.string()).optional(),
  capturedAfter: z.string().datetime({ offset: true }).optional(),
  capturedBefore: z.string().datetime({ offset: true }).optional(),
  // TODO: align with portal filter UI once designs land
});
export type MilestoneFilterSpec = z.infer<typeof MilestoneFilterSpecSchema>;

export const MilestoneSchema = z.object({
  id: z.string().uuid(),
  gameId: z.string().uuid(),
  name: z.string().min(1),
  description: z.string().nullable(),
  researchFocus: z.string().nullable(),
  filterSpec: MilestoneFilterSpecSchema,
  createdByUserId: z.string().uuid().nullable(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
});
export type Milestone = z.infer<typeof MilestoneSchema>;
